<script setup lang="ts">

import { faFilterCircleXmark, faReceipt } from '@fortawesome/pro-regular-svg-icons'

import { FilterDateRange } from '@shared/ui/filters'
import { BtnIcon, BtnPrimary } from '@shared/ui/buttons'
import { AppInput } from '@shared/ui/inputs'
import { AppSelect } from '@shared/ui/selects'
import { AppIcon } from '@shared/ui/icons'

import { useFiltersPromocodes } from '../model/filters-promocodes.hook'

defineOptions({
  name: 'FiltersPromocodes',
})

const {
  refSearch,
  refStatus,
  refDiscount,
  refDateRange,
  statusOptions,
  discountOptions,
  canManage,
  isLoading,
  clearFilters,
  openCreateModal,
} = useFiltersPromocodes()
</script>

<template>
  <div class="filters-promocodes">
    <div class="filters-promocodes__fields">
      <AppInput
        v-model="refSearch"
        class="filters-promocodes__search"
        label="Search"
        placeholder="Promo code"
      />

      <FilterDateRange
        v-model="refDateRange"
        class="filters-promocodes__date"
        label="Date"
        placeholder="Select range"
      />

      <AppSelect
        v-model="refStatus"
        class="filters-promocodes__select"
        :options="statusOptions"
        label="Status"
        placeholder="All"
        :disabled="isLoading"
        clearable
      />

      <AppSelect
        v-model="refDiscount"
        class="filters-promocodes__select"
        :options="discountOptions"
        label="Discount"
        placeholder="All"
        :disabled="isLoading"
        clearable
      />
    </div>

    <div class="filters-promocodes__controls">
      <BtnIcon
        :icon="faFilterCircleXmark"
        color="red"
        tooltip-text="Clear filters"
        :disabled="isLoading"
        @click="clearFilters"
      />

      <BtnPrimary
        v-if="canManage"
        text="Create promo code"
        color="emerald"
        element-width="auto"
        :disabled="isLoading"
        @click="openCreateModal"
      >
        <template #iconLeft>
          <AppIcon
            :icon="faReceipt"
            color="white"
          />
        </template>
      </BtnPrimary>
    </div>
  </div>
</template>

<style scoped lang="scss" src="./FiltersPromocodes.scss" />
